module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "roll clearfix"
  }, [_c('div', {
    staticClass: "roll-item"
  }, [_c('total-title', {
    attrs: {
      "type": 1
    },
    on: {
      "clickMth": function($event) {
        _vm.goMore(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "roll-item-content"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "img-box animated-left"
  }, _vm._l((_vm.items_find), function(item) {
    return _c('ts-image', {
      attrs: {
        "width": "120",
        "canView": false,
        "disabledHover": "",
        "height": "120",
        "src": item.searchSource
      },
      on: {
        "click": function($event) {
          _vm.goFind(item.id)
        }
      }
    })
  }))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "roll-item"
  }, [_c('total-title', {
    attrs: {
      "type": 2
    },
    on: {
      "clickMth": function($event) {
        _vm.goMore(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "roll-item-content"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "animated-left",
    on: {
      "click": function($event) {
        _vm.goMore(2)
      }
    }
  }, [_c('div', {
    staticClass: "img-box1",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, _vm._l((_vm.items_new), function(item) {
    return _c('ts-image', {
      attrs: {
        "width": "120",
        "canView": false,
        "disabledHover": "",
        "height": "120",
        "src": item.productList[0].defaultPicUrl
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "img-box1"
  }, _vm._l((_vm.items_hot), function(item) {
    return _c('ts-image', {
      attrs: {
        "width": "120",
        "canView": false,
        "disabledHover": "",
        "height": "120",
        "src": item.pics[0]
      }
    })
  }))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "roll-item"
  }, [_c('total-title', {
    attrs: {
      "type": 3
    },
    on: {
      "clickMth": function($event) {
        _vm.goMore(3)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "roll-item-content"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden",
      "height": "260px"
    }
  }, [_c('div', {
    staticClass: "p-box animated-top"
  }, _vm._l((_vm.items_enter), function(item) {
    return _c('p', {
      on: {
        "click": function($event) {
          _vm.goEnter(item.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.companyName))]), _vm._v(" "), _c('span', {
      staticClass: "fr time"
    }, [_vm._v(_vm._s(_vm._f("filterDate1")(item.createDate)))])])
  }))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "roll-item"
  }, [_c('total-title', {
    attrs: {
      "type": 4
    },
    on: {
      "clickMth": function($event) {
        _vm.goMore(4)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "roll-item-content"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden",
      "height": "260px"
    }
  }, [_c('div', {
    staticClass: "p-box animated-top"
  }, _vm._l((_vm.items_buySupply), function(item) {
    return _c('p', {
      on: {
        "click": function($event) {
          _vm.goSupplyOrBuy(item)
        }
      }
    }, [_c('span', {
      staticClass: "info fl",
      attrs: {
        "title": item.description
      }
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('span', {
      staticClass: "fr time"
    }, [_vm._v(_vm._s(_vm._f("filterDate1")(item.createDate)))])])
  }))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-31eccfa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePageLists/roll-list.vue
// module id = 818
// module chunks = 39